export default __webpack_public_path__ + "static/media/02-Acceder-webinar-tecnico.7ca0bf65.png";